export default {

    transformCSS(data) {
        return `${data.property}:${data.value};`;
    },
    generateCSS(object) {
        let result = '';

        for (const key in object) {
            if (object.hasOwnProperty(key)) {
                const element = object[key];
                result += `
 .${key}
    {
    ${element}
    }
`
            }
        }

        return result;
    },
    generateTheme(object) {
        let theme ={
            text: "#FFFFFF",
            foreground: "rgba(248,248,248,1)",
            background: "rgba(33, 33, 33, 1)"
        } 

        for (const key in object) {
            if (object.hasOwnProperty(key) && theme.hasOwnProperty(key)) {
                const element = object[key];
                theme[key] = element.value;
            }
        }

        const config = {plugins:{react:{theme}}};

        return JSON.stringify(config,null,'\t').replace(/\n/g,'<br>').replace(/\t/g,'&nbsp;&nbsp;&nbsp;');
    },

     objToString(obj) {
        var str = '';
        for (var p in obj) {
            if (obj.hasOwnProperty(p)) {
                str += p + '::' + obj[p] + '\n';
            }
        }
        return str;
    }

}

